import { r as registerInstance, c as createEvent, h } from './index-5faac9d7.js';
import { a as EApcButtonType, E as EAvailabilityType } from './currency-49e0d692.js';
import { g as getDownloadButtonLabel, b as getDownloadButtonIcon } from './utils-cdf9de4e.js';
import './isEmpty-ea893565.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';

const ctaAreaApcContainerCss = ":host{display:block}@media screen and (min-width: 980px){:host{border-top:1px solid #e7e6e6}}.apc-cta-area{display:block}@media screen and (max-width: 979px){.apc-cta-area{padding:20px 16px;background:#fafafa;border:1px solid #e7e6e6}}@media screen and (min-width: 980px){.apc-cta-area{padding:24px 0}}.apc-cta-area__container{display:flex;flex-direction:column}@media screen and (min-width: 980px){.apc-cta-area__container{max-width:320px}}@media screen and (min-width: 980px){.apc-cta-area__row+.apc-cta-area__row{margin-top:20px}}@media screen and (max-width: 979px){.apc-cta-area__row+.apc-cta-area__row{margin-top:16px}}.apc-cta-area__skeleton{--se-divider:#e6e6e6;--se-background-standard:#ffffff}@media screen and (min-width: 980px){.apc-cta-area__skeleton+.apc-cta-area__skeleton{margin-top:8px}}";

const CtaAreaApcContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.apcCtaButtonDidClick = createEvent(this, "apcCtaButtonDidClick", 7);
    this.getButtonType = () => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[this.productId]) || null;
      switch (availabilityType) {
        case EAvailabilityType.ADD_TO_CART:
        case EAvailabilityType.PURCHASE_CD:
          return EApcButtonType.ADD_TO_CART;
        default:
          return EApcButtonType.DOWNLOAD_BUTTON;
      }
    };
    this.getPrices = () => {
      var _a, _b, _c;
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = (_c = (_b = (_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[this.productId]) !== null && _c !== void 0 ? _c : {};
      return {
        priceLabel: priceLabel || null,
        previousPriceValue: previousPriceValue || null,
        VATInclused: VATInclused || null,
        previousPrice: previousPrice || null,
        activePrice: activePrice || null,
        activePriceNoTax: activePriceNoTax || null,
        activePriceValue: activePriceValue || null,
      };
    };
    this.handleClick = (event) => {
      this.apcCtaButtonDidClick.emit({
        initialEvent: event,
        buttonType: this.getButtonType(),
        isStickyBar: this.isStickyBar,
      });
    };
    this.apcCta = undefined;
    this.ctaData = undefined;
    this.productId = undefined;
    this.availabilityInfo = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.addToMyProductsLabel = undefined;
    this.softwareDocuments = undefined;
    this.downloadLabel = undefined;
    this.showSkeleton = false;
    this.isStickyBar = false;
    this.isInMyProductsList = false;
    this.isInFavorites = false;
    this.showFavorites = false;
    this.showCompare = undefined;
    this.compareLabel = undefined;
  }
  renderButton() {
    var _a, _b, _c, _d;
    const buttonType = this.getButtonType();
    const emphasized = {
      importance: 'emphasized',
      onClick: this.handleClick,
    };
    if (buttonType === EApcButtonType.ADD_TO_CART) {
      emphasized.label = (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel;
      emphasized.icon = "shopping-cart";
    }
    else if (buttonType === EApcButtonType.DOWNLOAD_BUTTON) {
      const button = (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d["DOWNLOAD_BUTTON"];
      emphasized.label = getDownloadButtonLabel(this.softwareDocuments, button, this.downloadLabel);
      emphasized.icon = getDownloadButtonIcon(this.softwareDocuments);
    }
    if (!emphasized.label) {
      return null;
    }
    return {
      emphasized,
    };
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    const prices = this.getPrices();
    if (this.isStickyBar) {
      return (h("pes-cta-area-view-sticky", { priceHTML: prices.activePrice, buttons: this.renderButton(), isInFavorites: this.isInFavorites, showFavorites: this.showFavorites, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, imageUrl: this.imageUrl, imageTitle: this.imageTitle }));
    }
    return (h("pes-cta-area-view", { productId: this.productId, priceHTML: prices.activePrice, previousPriceHTML: prices.previousPrice, inStockLabel: (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.inStockLabel, vatLabel: (prices === null || prices === void 0 ? void 0 : prices.VATInclused) && ((_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.vatLabel), resellerLabel: prices.priceLabel, buttons: this.renderButton(), showSkeleton: this.showSkeleton, addedToCartLabel: (_f = (_e = this.ctaData) === null || _e === void 0 ? void 0 : _e.labels) === null || _f === void 0 ? void 0 : _f.addedToCart, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.showFavorites, showAddedToCartLabel: this.isInMyProductsList, isInFavorites: this.isInFavorites, showCompare: this.showCompare, compareLabel: this.compareLabel }));
  }
};
CtaAreaApcContainer.style = ctaAreaApcContainerCss;

export { CtaAreaApcContainer as pes_cta_area_apc_container };
